/**
 * @author Michael Brown
 * @date 2021-05-03
 * @param {object} providerId
 * @param {object} businessCode
 * @returns {object}
 */
export async function bookingStepClicked(providerId, businessCode, fromDate) {
  // Bail when param is empty
  if (!providerId || !businessCode) {
    return;
  }

  const hostname = '//' + location.hostname;
  const endpointPath = '/data/AjaxAnalytics/BookingStepClick?businessCode=';

  const response = await fetch(
    hostname + endpointPath + businessCode.BusinessCode,
    {
      method: 'POST',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        providerId: providerId.ProviderId,
        businessCode: businessCode.BusinessCode,
        fromDate: fromDate,
      }),
    }
  );
  return response.json();
}
